import React, { useState } from "react"
import PropTypes from "prop-types"
import DataTableItem from "./DataTableItem"
import CustomDrawer from "ui/Drawer";
import { Button } from "antd";

const DataTableResponsive = ({ data, onItemClick, extraRows, actionIcon, getTableActions }) => {
  const [openActionDrawer, setOpenActionDrawer] = useState(false)
  const [currentRow, setCurrentRow] = useState(null);
  return (
    <div>
      {data.map((listData) => (
        <DataTableItem extraRows={extraRows} key={listData?.id} data={listData} actionIcon={actionIcon} setOpenActionDrawer={setOpenActionDrawer} onClick={() => onItemClick?.(listData)} onActionIconClick={() => {
          setCurrentRow(listData);
          setOpenActionDrawer(true);
        }} />
      ))}

      <CustomDrawer open={openActionDrawer} setOpen={setOpenActionDrawer} title="More Actions"> {getTableActions?.(currentRow)?.map((action, idx) => (
        <Button
          key={action.label || idx}
          variant={action.variant || 'default'}
          color={action.color || 'default'}
          className="w-full mb-2"
          onClick={() => action.onClick(currentRow)}
        >
          {action.label}
        </Button>
      ))}</CustomDrawer>
    </div>
  )
}

DataTableResponsive.propTypes = {
  data: PropTypes.array.isRequired,
  onItemClick: PropTypes.func,
  extraRows: PropTypes.node,
  actionIcon: PropTypes.node,
  getTableActions: PropTypes.func,
}

export default DataTableResponsive
